import { render, staticRenderFns } from "@/components/Layout/Menu/Reportes/Reportes_bop/Reportes_bop_documentos/Reportes_bop_documentos.html?vue&type=template&id=3232d3af&scoped=true&"
import script from "@/components/Layout/Menu/Reportes/Reportes_bop/Reportes_bop_documentos/Reportes_bop_documentos.js?vue&type=script&lang=js&"
export * from "@/components/Layout/Menu/Reportes/Reportes_bop/Reportes_bop_documentos/Reportes_bop_documentos.js?vue&type=script&lang=js&"
import style0 from "@/components/Layout/Menu/Reportes/Reportes_bop/Reportes_bop_documentos/Reportes_bop_documentos.css?vue&type=style&index=0&id=3232d3af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3232d3af",
  null
  
)

export default component.exports